import Table from "../Commons/Table";
import { dateFormatter } from "../../lib/formatter";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { AnnouncementListProps } from "../../types/announcement";

/* styled */

const ContentTopButtonForm = styled.div`
  float: right;
  margin: 1.25rem auto;

  .center {
    display: block;
    padding-top: 0;

    .detail {
      right: 0;
    }
    .pl20 {
      padding-left: 1.25rem;
    }
  }
`;
const ContentButton = styled.button`
  height: 2.3rem;
  min-width: 5rem;
  padding: 0.5rem;
  border-radius: 0.35rem;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: #044dac;
  border: 0px;
  cursor: pointer;
  box-shadow:
    0 0 1px 0 rgb(0 0 0 / 20%),
    0 2px 4px -2px rgb(0 0 0 / 30%);

  :hover {
    background-color: #4c9ffe;
  }
  :disabled {
    background-color: #949494;
    cursor: default;
  }
`;

const AnnouncementList = ({
  announcementListItems,
  filterItem,
  userRole,
  announcementListTotal,
  handleFilter,
  handleInitFilter,
  handleToggle,
  handleAnnouncementCreateModal,
  handleAnnouncementUpdateModal,
  handleAnnouncementDeleteModal,
}: AnnouncementListProps) => {
  return (
    <>
      {/* <ContentTitle>
        <Filter
          columns={[
            {
              key: "title",
              size: "lg",
              placeholder: "제목",
              value: filterItem.title,
              action: handleFilter,
            },
          ]}
          init={handleInitFilter}
        />
      </ContentTitle> */}
      {userRole === "master" ? (
        <ContentTopButtonForm>
          <ContentButton onClick={handleAnnouncementCreateModal}>
            <FontAwesomeIcon icon={faPlusCircle} />
            <span>공지사항 등록</span>
          </ContentButton>
        </ContentTopButtonForm>
      ) : (
        <div style={{ paddingTop: "1.25rem" }}></div>
      )}
      <Table
        columns={[
          {
            key: "id",
            text: "게시물 번호",
            width: "5%",
          },
          {
            key: "title",
            text: "제목",
            width: "23%",
          },
          {
            key: "toggle",
            text: "노출 여부",
            width: "10%",
            toggle: {
              valueKey: "is_published",
              onChange: {
                func: handleToggle,
                params: ["id"],
              },
            },
          },
          {
            key: "sort_order",
            text: "노출 순서",
            width: "10%",
          },
          {
            key: "creator",
            text: "작성자",
            width: "20%",
          },
          {
            key: "created_at",
            text: "생성 일자",
            width: "20%",
            formatter: {
              func: dateFormatter,
              params: ["created_at"],
            },
          },
          {
            key: "updated_at",
            text: "수정 일자",
            width: "20%",
            formatter: {
              func: dateFormatter,
              params: ["updated_at"],
            },
          },
          {
            key: "button",
            text: "",
            width: "5%",
            items: [
              {
                text: "수정",
                action: {
                  func: (
                    id: number,
                    title: string,
                    content: string,
                    is_published: boolean,
                    sort_order: string,
                  ) =>
                    handleAnnouncementUpdateModal({
                      id,
                      title,
                      content,
                      is_published,
                      sort_order,
                    }),
                  params: [
                    "id",
                    "title",
                    "content",
                    "is_published",
                    "sort_order",
                  ],
                },
              },
              {
                text: "삭제",
                action: {
                  func: (id: number, title: string) =>
                    handleAnnouncementDeleteModal({ id, title }),
                  params: ["id", "title"],
                },
              },
            ],
          },
        ]}
        datas={announcementListItems}
        userRole={userRole}
        total={announcementListTotal}
      />
    </>
  );
};

export default AnnouncementList;
